import React, { useState } from 'react';
import { API } from '../config';

export default function NeedForm({ categories, currentUser }) {
  const [category, setCategory] = useState('');
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [result, setResult] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setSubmitting(true);
    try {
      const res = await fetch(API.needs, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          userId: currentUser.id,
          userName: currentUser.name,
          category,
          title,
          description,
        })
      });
      const data = await res.json();
      setResult(data);
      setTitle('');
      setDescription('');
    } catch {}
    setSubmitting(false);
  }

  return (
    <div>
      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        <select value={category} onChange={e => setCategory(e.target.value)} required style={s.select}>
          <option value="">选择分类</option>
          {(categories || []).map(c => <option key={c} value={c}>{c}</option>)}
        </select>
        <input value={title} onChange={e => setTitle(e.target.value)} placeholder="标题，例：找初三(3)班的同学" required style={s.input} />
        <textarea value={description} onChange={e => setDescription(e.target.value)} placeholder="写下你想说的话，AI 会自动匹配同校或同班的校友" rows={3} required style={s.textarea} />
        <button type="submit" disabled={submitting} style={{ ...s.btn, opacity: submitting ? 0.6 : 1 }}>
          {submitting ? '发布中...' : '发布动态'}
        </button>
      </form>

      {result && (
        <div style={{ marginTop: 12, padding: 12, background: '#fce4ec', borderRadius: 8 }}>
          <div style={{ fontWeight: 600, marginBottom: 6, color: '#e91e63' }}>✅ 发布成功！AI 匹配到的校友：</div>
          {result.matches && result.matches.length > 0 ? (
            result.matches.map((m, i) => (
              <div key={i} style={{ padding: '8px 0', borderBottom: i < result.matches.length - 1 ? '1px solid #f8bbd0' : 'none', fontSize: 14 }}>
                <strong>{m.mate.name}</strong>
                <span style={{ marginLeft: 8, background: i === 0 ? '#e91e63' : '#9e9e9e', color: '#fff', padding: '1px 8px', borderRadius: 10, fontSize: 12 }}>
                  {Math.round(m.score * 100)}% 匹配
                </span>
                <div style={{ color: '#666', fontSize: 13 }}>{m.mate.schoolName} · {m.mate.gradYear}届 · {m.mate.className || ''} {m.mate.headTeacher ? `· 班主任 ${m.mate.headTeacher}` : ''}</div>
              </div>
            ))
          ) : (
            <div style={{ color: '#666' }}>暂时没有匹配到校友，等更多人加入后会自动匹配</div>
          )}
        </div>
      )}
    </div>
  );
}

const s = {
  input: { padding: '8px 12px', border: '1px solid #ddd', borderRadius: 6, fontSize: 14 },
  textarea: { padding: '8px 12px', border: '1px solid #ddd', borderRadius: 6, fontSize: 14, resize: 'vertical' },
  select: { padding: '8px 12px', border: '1px solid #ddd', borderRadius: 6, fontSize: 14, background: '#fff' },
  btn: { padding: '10px', border: 'none', borderRadius: 6, background: '#e91e63', color: '#fff', fontSize: 15, cursor: 'pointer' }
};
